export const getAuthToken = async (): Promise<string> => {
  try {
    const url = `${process.env.REACT_APP_SERVER_URL}/auth/signin`;

    const currentDate = new Date();

    const formattedDate = currentDate.toISOString().split('.')[0];

    const data = {
      client_id: `${process.env.REACT_APP_CLIENT_ID}`,
      client_password: `${process.env.REACT_APP_CLIENT_PASSWORD}`,
      current_user: {
        user_id: '21620',
        membership: 'free',
        sign_up_date: formattedDate
      }
    };

    // console.log('body data', data);

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error('Request failed');
    }

    const responseData = await response.json();
    return responseData.accessToken;
  } catch (error) {
    console.error('Something went wrong when signing in', error);
    throw error;
  }
};
